import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import store from "../../reducers/createReducers";
import GLOBAL_ACTIONS from "../../actions/global-actions";
import InstrumentIcon from "../../components/instrument-icon";
import {useTranslation} from "react-i18next";
import SvgIcon from "../../components/svg-icon";

const GaeCurrencyAndMode = props => {
    const {t} = useTranslation()
    const {currencies, onClick, game} = props

    const {gameSelectedCurrency} = useSelector(state => state.globalReducer)
    const {authenticated} = useSelector(state => state.authenticationReducer)

    const [search, setSearch] = useState('')
    const [filteredCurrencies, setFilteredCurrencies] = useState([])

    useEffect(() => {
        setFilteredCurrencies(currencies?.filter(
            i => i?.toUpperCase().includes(search?.toUpperCase())))
    }, [currencies, search])


    const handlePlay = type => onClick(type)

    const handleChangeWallet = wall => {

        document.getElementById('modalWalet0')?.classList?.remove('show')
        document.getElementById('dropdown-menu-modal__wallet-menu')?.classList?.remove('show')
        setSearch('')

        store.dispatch(GLOBAL_ACTIONS.setSelectedCurrency(wall))
    }


    // console.log('gameSelectedCurrency = ', gameSelectedCurrency)
    return (

        <div className="frame__nav">
            <div className="frame__balance">

                <span>{t('game.balance-in')}</span>

                <div className="dropdown frame-mob__dropdown">

                    <button
                        className="frame-mob__dropdown-btn g-8"
                        type="button"
                        id="frameDrop1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                        <InstrumentIcon code={gameSelectedCurrency}/>
                        {gameSelectedCurrency}
                        <SvgIcon id={'right-down'}/>
                    </button>


                    <div className="dropdown-menu frame-mob__menu" aria-labelledby="frameDrop1">
                        <div className="frame-mob__search">
                            <input
                                value={search}
                                name="search"
                                onChange={e => setSearch(e.target.value)}
                                type="text" className="search__input"
                                placeholder={t('casino.search','Search')}

                                // placeholder="Search"
                            />
                        </div>
                        <ul className="frame-mob__currencies">
                            {
                                filteredCurrencies?.map((wall, o) => (
                                    <li key={o} onClick={e => handleChangeWallet(wall)}>
                                        <span className="gapp2">
                                            <InstrumentIcon code={wall}/>
                                            {wall}
                                        </span>
                                    </li>
                                ))
                            }

                        </ul>
                    </div>

                </div>

            </div>
            <div className="frame__btns">

                {
                    authenticated ? <button
                            onClick={e => handlePlay('real')}
                            className="frame__btn" type="button">
                            {t('game.real-play')}
                        </button> :
                        <button
                            onClick={e => handlePlay('register')}
                            className="frame__btn" type="button">
                            {t('general.sign-up')}
                        </button>
                }

                {
                    game?.is_live || !game?.has_demo ? null :
                        <button
                            onClick={e => handlePlay('demo')}
                            className="frame__play" type="button">
                            <SvgIcon id={'play'}/>
                            {t('game.demo-play')}

                        </button>
                }

            </div>
        </div>
    )

}

export default GaeCurrencyAndMode
